<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Settings</el-breadcrumb-item>
                <el-breadcrumb-item>Office Country</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="18">
                <div class="main-title">
                    Office Country List
                </div>
            </el-col>
            <el-col :span="6" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="isEdit = false; resetForm(); showCreateDialog = true">New Country</el-button>
            </el-col>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4" >
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                        </el-col>
                    </el-row>

                    <el-table
                            v-loading="loading"
                            :data="countries"
                            stripe
                            @sort-change="sortChange"
                            :default-sort="query.sort"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="ID"
                                width="80"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name"
                                width="200"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                label="Code"
                                width="100"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="Description"
                                sortable>
                        </el-table-column>

                        <el-table-column
                                prop="active"
                                label="Status"
                                width="100"
                                sortable>
                            <template slot-scope="scope">
                                {{scope.row.active ? 'Active':'Inactive'}}
                            </template>
                        </el-table-column>
                        <el-table-column 
                                width="100"
                                label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="isEdit = true; edit(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="searchData" />
                </el-card>
            </el-col>
        </el-row>
        <el-dialog v-bind:title="dialogTitle" :visible.sync="showCreateDialog">
            <el-form :model="form" ref="countryForm" :rules="countryRules" v-loading="saving">
                <el-form-item :required="true" label="Country" :label-width="formLabelWidth" prop="country">
                    <el-select
                            value-key="country"
                            v-model="form.country"
                            v-loading="countryLoading"
                            filterable
                            placeholder="Select Country"
                            :disabled="isEdit">
                        <el-option
                                v-for="item in countryData"
                                :key="item.country"
                                :label="item.country"
                                :value="item">
                            <span style="float: left">{{ item.country }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.abbreviation }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Description" :label-width="formLabelWidth" prop="description">
                    <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item >
                    <div class="switch-label" style="width: 108px;" >Active</div> <el-switch v-model="form.active"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showCreateDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="save()">Save</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import _ from "lodash";
import countryData from "country-json/src/country-by-abbreviation.json";
import Pagination from "@/components/Pagination"
import api from "@/services/api/WRCService"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        var validateCountry = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please select Country'));
            } else {
                if (_.isUndefined(this.form.id)) {
                    this.countryLoading = true;
                    
                    api.getCountries(value.country, {
                        page: 0,
                        size: 200
                    }).then(({data}) => {
                        if (data.data.items.length == 0) {
                            callback();
                        } else {
                            callback(new Error('Country already exist in record.'));
                        }
                    }).catch(() => {
                        callback();
                    }).then(() => {
                        this.countryLoading = false;
                    });
                } else {
                    callback();
                }
            }
        };
        return {
            countryRules: {
                country: [
                    { validator: validateCountry, trigger: 'change' }
                ]
            },
            showCreateDialog: false,
            formLabelWidth: '120px',
            form: {
              name: '',
              description: '',
              active: true
            },
            dialogTitle: 'New Office Country',
            saving: false,
            loading: false,
            countryLoading: false,
            countries: [],
            countryData:[],
            isEdit: false,
            statuses: [
                "All", "Active", "Inactive"
            ],
            query: {
                status: "Active",
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: null,
                sort: {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                }
            }
        }
    },
    watch: {
        form : function() {
            if (_.isUndefined(this.form.id)) {
                this.dialogTitle = 'New Office Country';
            } else {
                this.dialogTitle = 'Edit Office Country';
            }
        }
    },
    methods:{
        search() {
            this.query.page = 1;
            this.searchData();
        },
        queryStatusChanged() {
            this.search()
        },
        searchData() {
            this.loading = true;

            var active = null

            if (this.query.status === "Active") {
                active = true
            } else if (this.query.status === "Inactive") {
                active = false
            }

            api.getCountries(this.query.search,{
                page: this.query.page - 1,
                size: this.query.limit,
                sort: this.query.sort.prop,
                dir: this.query.sort.orderVal,
            }, active).then(({ data }) => {

                this.countries.splice(0, this.countries.length);
                this.countries.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        edit(idx, data) {
            var country = _.find(this.countryData, function(c) { return c.country === data.name; });
            this.form = {
                id: data.id,
                country: country,
                description: data.description,
                active: data.active
            };

            this.showCreateDialog = true;
        },
        resetForm() {
            this.saving = false;

            this.form = {
              description: '',
              active: true
            }

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['countryForm'])) {
                    this.$refs['countryForm'].clearValidate();
                }
            }, 1);
        },
        sortChange(data) {
            const { prop, order } = data;
            if(prop == null){
                this.query.sort = {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                };
            }else {
                this.query.sort = {
                    prop: prop,
                    order: order,
                    orderVal: order === 'ascending' ? 'asc' : 'desc'
                }
            }

            this.searchData()
        },
        save() {
            this.$refs['countryForm'].validate((valid) => {
                if (valid) {
                    this.saving = true;
                    if (_.isUndefined(this.form.id)) {
                        api.createCountries(this.form).then(() => {
                            this.$message({
                              message: 'Successfully added Office Country.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    } else {
                        let params = {
                            countryId: this.form.id,
                            description: this.form.description,
                            active: this.form.active
                        }

                        api.updateOfficeCountry(params).then(() => {
                            this.$message({
                              message: 'Successfully updated Office Country.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
    mounted() {
        this.query.page = 1;
        this.searchData();
        this.countryData = countryData;
    }
}
</script>
